/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./action-column.vue?vue&type=template&id=08874110&"
import script from "./action-column.vue?vue&type=script&lang=js&"
export * from "./action-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports